import React from 'react'
import Icon from '../../../../../common/Icon'
import TrashIcon from '../../../../../common/icons/TrashIcon'

const ShapeThumbItem = ({
    item,
    itemKey,
    buttonClassName = 'SidebarPanel__ShapeThumb',
    ariaLabel,
    title,
    onClick,
    onDelete,
    deleteAriaLabel,
    actions = [],
    children,
}) => {
    return (
        <div key={itemKey} className="SidebarPanel__ShapeThumbWrap">
            <button
                type="button"
                className={buttonClassName}
                onClick={() => onClick?.(item)}
                aria-label={ariaLabel}
                title={title}
            >
                {children}
            </button>
            {actions.map(({key, className, onAction, ariaLabel: actionAriaLabel, content}) => (
                <button
                    key={key}
                    type="button"
                    className={className}
                    onClick={(e) => {
                        e.stopPropagation()
                        onAction?.(item)
                    }}
                    aria-label={actionAriaLabel}
                >
                    {content}
                </button>
            ))}
            {onDelete && (
                <button
                    type="button"
                    className="SidebarPanel__ShapeThumbDelete"
                    onClick={(e) => {
                        e.stopPropagation()
                        onDelete(item)
                    }}
                    aria-label={deleteAriaLabel}
                >
                    <Icon icon={TrashIcon} width={14} height={14} />
                </button>
            )}
        </div>
    )
}

export default ShapeThumbItem
